// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pageHeaderStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

pageHeaderStyles.gridItem = { width: 12 };
pageHeaderStyles.heading = {
    css: css`
        margin-bottom: 20px;
    `,
};
pageHeaderStyles.buttonsWrapper = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: fixed;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    z-index: 1;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
};
pageHeaderStyles.continueButton = {
    css: css`
        width: 100%;
    `,
};
